import NamePlateComponent from "@/components/dashboard/general/svgs/NamePlateComponent";
import { convertLetters } from "@/utils/letterConversion";
import { Link } from "react-router-dom";

const RUNES = [
    { name: "COIN", path: "coin", file: "01 COIN.svg" },
    { name: "LOCKET", path: "locket", file: "02 LOCKET.svg" },
    { name: "PRISM", path: "prism", file: "03 PRISM.svg" },
    { name: "SLATE", path: "slate", file: "04 SLATE.svg" },
    { name: "EARTH", path: "earth", file: "05 EARTH.svg" },
    { name: "HEX", path: "hex", file: "06 HEX.svg" },
    { name: "TOME", path: "tome", file: "07 TOME.svg" },
    { name: "OCTA", path: "octa", file: "08 OCTA.svg" },
    { name: "SKY", path: "sky", file: "09 SKY.svg" },
];

export default function ForgeRuneSelectionPage() {
    const title = convertLetters("Runestone Carving");
    const subtitle = convertLetters("Choose your rune and carve your stone!");

    return (
        <>
            <div className="mt-5 grid grid-cols-3 gap-20 p-20">
                <div className="col-span-3 flex items-center justify-center pt-10">
                    <h1
                        className="font-prviking border-text text-brand text-center text-9xl"
                        dangerouslySetInnerHTML={{ __html: title }}
                    />
                </div>
                <div className="col-span-3 flex items-center justify-center">
                    <h2 className="font-prviking border-text text-brand text-center text-7xl">
                        <span dangerouslySetInnerHTML={{ __html: subtitle }} />
                    </h2>
                </div>

                {RUNES.map((rune) => (
                    <div key={rune.path} className="col-span-3 xl:col-span-1">
                        <div className="flex items-center justify-center">
                            <div className="relative">
                                <Link
                                    to={`/runestone-carving/runes/${rune.path}`}
                                >
                                    <img
                                        src={`/runes/${rune.file}`}
                                        alt={`${rune.name} Rune`}
                                        className="border-brand h-80 w-80 rounded-lg border-8 p-4"
                                        style={{
                                            backgroundImage: `url(/wallhalla-blank-wall.png)`,
                                        }}
                                    />
                                    <NamePlateComponent
                                        text={rune.name}
                                        className="absolute bottom-[-15px] left-1/2 z-10 -translate-x-1/2 transform"
                                    />
                                </Link>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </>
    );
}
